import React, { useState } from "react";
import { deleteField } from "firebase/firestore";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import useUpdateSurvey from "hooks/surveys/useUpdateSurvey";

const FinishButton = ({ survey }) => {
  const [open, setOpen] = useState(false);
  const { updateSurvey } = useUpdateSurvey();

  const givenTime = new Date(survey.deadline);
  const now = new Date();
  const isPast = givenTime < now;

  return (
    <div className="flex justify-center">
      <div className="flex flex-col gap-2 text-center w-full">
        {!isPast && survey.type !== "finished" && (
          <span className="text-[12px] font-[700] text-gray-600">
            Ժամանակից շուտ`
          </span>
        )}
        <Button
          color={survey.type === "finished" ? "success" : "error"}
          variant="contained"
          className="w-full text-[12px] rounded-[24px]"
          onClick={() => {
            setOpen(true);
          }}
        >
          {survey.type === "finished" ? "Ավարտված է" : "Ավարտել"}
        </Button>
      </div>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{survey.title}</DialogTitle>
        <DialogContent dividers>
          <div className="flex flex-col gap-[24px] p-[24px]">
            <span className="text-[#212121] text-[12px] line-clamp-6">
              {survey.description}
            </span>
            <div className="flex flex-wrap gap-6">
              {survey.choices?.map((choice) => {
                return (
                  <Button
                    key={choice.id}
                    color={choice.id === survey.result ? "success" : "info"}
                    variant="contained"
                    className="w-fit rounded-[24px]"
                    onClick={() => {
                      updateSurvey(survey.id, {
                        type: "finished",
                        result: choice.id,
                      });
                      setOpen(false);
                    }}
                  >
                    {choice.value}
                  </Button>
                );
              })}

              <Button
                color="warning"
                variant="contained"
                className="w-fit rounded-[24px]"
                onClick={() => {
                  updateSurvey(survey.id, {
                    type: "pending",
                    result: deleteField(),
                  });
                  setOpen(false);
                }}
              >
                Չեղարկել արդյունքը
              </Button>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => setOpen(false)}>
            Փակել
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default FinishButton;
